import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Button, Col, Form, Row, Typography } from 'antd'
import { Formik } from 'formik'

import CustomInput from '../../components/CustomInput/customInput'
import CustomSelect from '../../components/CustomSelect/customSelect'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
import { isAdmin, isGR, isRtv } from '../../util/profiles'

const ListActionsPlanFilter = (props) => {
  const [filters, setFilters] = useState({
    safra: [],
    regions: [],
    districts: [],
    categorias: []
  })

  const [safra, setSafra] = useState([])
  const [safraAtual, setSafraAtual] = useState([])
  const [regions, setRegions] = useState([])
  const [districts, setDistricts] = useState([])

  const currentUser = useSelector((state) => state.auth.auth)

  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    fetchSafra({ active: true })
    fetchRegions({ active: true })
  }, [])

  useEffect(() => {
    if (loaded) {
      fetchCategories()
      setLoaded(false)
    }
  }, [loaded, filters])

  async function fetchSafra(params) {
    const referencePeriodsOptions = await request(api.listSafraDropdown(params))
    setSafra(referencePeriodsOptions)
    setFilters({ ...filters, safra: referencePeriodsOptions.at(-1).value })
  }

  async function fetchRegions(params) {
    const regions = await request(api.getRegionsDropdown(params))
    setRegions(regions)
    setLoaded(true)
  }

  async function fetchCategories() {
    const params = {
      idSafra: filters.safra,
      idRegion: filters.regions,
      idDistrict: filters.districts,
      categoria: filters.categorias,
      active: false
    }

    const categories = await api.listCategories(params)

    props.passData(categories, filters)
  }

  async function onChangeSafra(field) {
    const response = await api.findSafraByIdForActionPlan(field)
    setSafraAtual(response)
  }

  async function onChangeRegion(field) {
    const districtsByRegion = await request(api.getDistrictsDropdown({ regionId: field, active: true }))
    setDistricts(districtsByRegion)
  }

  async function onChangeDistrict(field) {
    setFilters({
      ...filters,
      districts: field,
      categorias: []
    })
  }

  async function onChangeCategorias(field) {
    setFilters({
      ...filters,
      categorias: field
    })
  }

  const handleClickFilter = () => {
    fetchCategories()
  }

  async function handleClickClearFilter() {
    if (isAdmin()) {
      const getAllDistricts = await request(api.getAllDistricts())

      const formattedDistricts = getAllDistricts.map((item) => ({
        value: item.id,
        description: item.districtName
      }))

      formattedDistricts.splice(0, 0, { value: '-1', description: ' TODOS' })

      setDistricts(formattedDistricts)
      setRegions(regions)

      setFilters({
        safra: safraAtual.id,
        regions: '-1',
        districts: '-1',
        categorias: []
      })
    } else if (isGR()) {
      setFilters({
        ...filters,
        safra: safraAtual.id,
        districts: '-1',
        categorias: []
      })
    } else if (isRtv(currentUser)) {
      setFilters({
        ...filters,
        safra: safraAtual.id,
        categorias: []
      })
    }
    setLoaded(true)
  }

  return (
    <div className="materials-filters">
      <Form layout="vertical">
        <Formik initialValues={{}} onSubmit={() => {}}>
          {({ errors, setFieldValue }) => {
            const setFieldValueWithState = (field, value) => {
              setFilters({ ...filters, [field]: value })
              return setFieldValue(field, value)
            }
            return (
              <>
                <Row type="flex" justify="start">
                  <CustomSelect
                    showSearch
                    field="safra"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    onChange={onChangeSafra}
                    rowSpan={6}
                    value={filters}
                    values={safra}
                    required
                  />
                  <CustomSelect
                    field="regions"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    onChange={onChangeRegion}
                    rowSpan={6}
                    value={filters}
                    values={regions}
                  />
                  <CustomSelect
                    showSearch
                    field="districts"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    onChange={onChangeDistrict}
                    rowSpan={6}
                    value={filters}
                    values={districts}
                  />
                  <CustomInput
                    field="categorias"
                    labelInput={getMessage('categoryOrActionName')}
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    onChange={onChangeCategorias}
                    rowSpan={6}
                    value={filters}
                  />
                </Row>
                <Row type="flex" justify="end">
                  <Col span={4}>
                    <Button
                      icon="search"
                      className="bgPrimary"
                      style={{ width: '100%' }}
                      type="dashed"
                      onClick={handleClickFilter}
                    >
                      {getMessage('search')}
                    </Button>
                  </Col>
                  <Col span={4}>
                    <Button
                      icon="close"
                      style={{
                        width: '100%',
                        borderColor: '#EE778F',
                        color: '#EE778F'
                      }}
                      type="ghost"
                      onClick={handleClickClearFilter}
                    >
                      {getMessage('cleanFilters')}
                    </Button>
                  </Col>
                </Row>
              </>
            )
          }}
        </Formik>
        <div className="horizontal-line" style={{ margin: '20px 0px 20px' }} />
        <div className="default-header-div">
          <div className="default-header-breadcrumb">
            <Typography.Title className="default-header-title" level={4}>
              {getMessage('locationsPlain')}
            </Typography.Title>
            <span>
              {safraAtual.actionPlanningPeriodStartDate !== 'Invalid date'
                ? `O período de planejamento das ações vai de ${safraAtual.actionPlanningPeriodStartDate} até
            ${safraAtual.actionPlanningPeriodEndDate}`
                : 'Não existe período definido para planejamento nesta safra'}
            </span>
          </div>
        </div>
      </Form>
    </div>
  )
}

export default ListActionsPlanFilter
